import type { ExportEntry } from '../types/export';

export function updateExportSegments(
  entry: ExportEntry,
  sceneId: string,
  segmentIds: string[] | undefined
): ExportEntry {
  const segments = (entry.segments ?? []).filter((item) => item.sceneId !== sceneId);
  if (segmentIds !== undefined) segments.push({ sceneId, segmentIds });
  return { ...entry, segments: segments.length ? segments : undefined };
}
